import { BarChart } from '@tremor/react'
import type { GemsByStream } from './types'

interface Props {
  data: GemsByStream[]
}

export function GemsPerStreamChart({ data }: Props) {
  if (data.length === 0) {
    return (
      <div className="rounded-lg border border-stone-200 dark:border-stone-800 bg-white dark:bg-stone-900/50 p-5">
        <h3 className="font-medium text-stone-900 dark:text-stone-100">Gems by Stream</h3>
        <div className="h-72 flex items-center justify-center text-sm text-stone-500 dark:text-stone-400">
          No gems flagged in the selected period
        </div>
      </div>
    )
  }

  // Transform data for the chart
  const chartData = data.map(item => ({
    name: item.streamName,
    'Gems': item.gemCount,
  }))

  return (
    <div className="rounded-lg border border-stone-200 dark:border-stone-800 bg-white dark:bg-stone-900/50 p-5">
      <h3 className="font-medium text-stone-900 dark:text-stone-100">Gems by Stream</h3>
      <p className="text-xs text-stone-500 dark:text-stone-400 mt-1">
        Number of flagged items per stream
      </p>

      <div className="mt-4 [&_.tremor-Legend-root]:hidden [&_text]:text-[10px] [&_text]:fill-stone-400">
        <BarChart
          className="h-64"
          data={chartData}
          index="name"
          categories={['Gems']}
          colors={['amber']}
          yAxisWidth={32}
          showAnimation
          showLegend={false}
          valueFormatter={(value) => value.toLocaleString()}
        />
      </div>

      <div className="mt-3 flex items-center gap-1.5 text-[10px] text-stone-500 dark:text-stone-400">
        <span className="w-2 h-2 rounded-full bg-amber-500" />
        <span>Gems</span>
      </div>
    </div>
  )
}
